import { render, staticRenderFns } from "./ModalManager.vue?vue&type=template&id=a4c45b04&"
import script from "./ModalManager.vue?vue&type=script&lang=js&"
export * from "./ModalManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports